import { FileAssignment } from "../pages/Courses/enums/FileAssignment.enum";
import {
	useDeleteCourseFileMutation,
	useUploadCourseFilesMutation,
} from "../redux/courses/courses.api";

export const useCourseFiles = () => {
	const [uploadCourseFiles, { isLoading: isUploading, error: uploadError }] =
		useUploadCourseFilesMutation();
	const [deleteCourseFile, { isLoading: isDeleting, error: deleteError }] =
		useDeleteCourseFileMutation();

	const upload = async (
		files: File[],
		fileAssignment: FileAssignment = FileAssignment.Content,
		courseId?: number
	) => {
		try {
			const formData = new FormData();

			files.forEach((file) => {
				formData.append("files", file);
			});

			formData.append("fileAssignment", fileAssignment);

			if (courseId) {
				formData.append("courseId", courseId.toString());
			}

			return uploadCourseFiles(formData).unwrap();
		} catch (e) {
			console.error("Error uploading", e);
		}
	};

	const removeFile = async (filePath: string, courseId?: number) => {
		try {
			await deleteCourseFile({ filePath, courseId }).unwrap();
		} catch (e) {
			console.error("Error deleting file", e);
		}
	};

	return {
		uploadCourseFiles: upload,
		deleteCourseFile: removeFile,
		isLoading: isUploading || isDeleting,
		error: uploadError || deleteError,
	};
};
